define(
	'NVT.SSO_MMechanism.SSOMechanism',
	[
		'NVT.SSO_Mechanism.SSOMechanism.View',
		'Utils',
		'Header.Menu.View',
		'Profile.Model',
		'NVT.SSO.Services.View'
	],
	function (
		SSOMechanismView,
		Utils,
		HeaderMenuView,
		ProfileModel,
		NVTSSOServicesView
	) {
		'use strict';

		return {
			mountToApp: function (container) {

				// let servicesCache = null;
				// function getSSOServices() {
				// 	if (servicesCache) {
				// 		return servicesCache;
				// 	}

				// 	const ssoView = new SSOMechanismView();
				// 	servicesCache = ssoView.getServicesForMenu() || [];
				// 	return servicesCache;
				// }

				// const originalChildViews = HeaderMenuView.prototype.childViews;
				// HeaderMenuView.prototype.childViews = _.extend({}, originalChildViews, {
				// 	'Header.SSO.Services': function () {
				// 		const profile = ProfileModel.getInstance();

				// 		if (profile.get('isLoggedIn') !== 'T') {
				// 			return null;
				// 		}
				// 		const services = getSSOServices();
				// 		if (!services || services.length === 0) {
				// 			return null;
				// 		}

				// 		return new NVTSSOServicesView({ services: services });
				// 	}
				// });

				// const originalGetContext = HeaderMenuView.prototype.getContext;
				// HeaderMenuView.prototype.getContext = function () {
				// 	const context = originalGetContext.apply(this, arguments);
				// 	const profile = ProfileModel.getInstance();
				// 	context.showSSOMenu = profile.get('isLoggedIn') === 'T';
				// 	return context;
				// };

				// function injectSSOServicesMenu() {
				// 	const profile = ProfileModel.getInstance();

				// 	const headerMenu = document.querySelector('.header-menu-level1');
				// 	if (!headerMenu) {
				// 		setTimeout(injectSSOServicesMenu, 300);
				// 		return;
				// 	}

				// 	if (document.querySelector('.sso-services-item')) {
				// 		return;
				// 	}

				// 	const menuItem = document.createElement('li');
				// 	menuItem.className = 'header-menu-item sso-services-item';

				// 	const toggleLink = document.createElement('a');
				// 	toggleLink.href = '/ssoservicelist';
				// 	toggleLink.className = 'header-menu-level1-anchor sso-services-toggle';
				// 	toggleLink.textContent = 'Services';

				// 	menuItem.appendChild(toggleLink);

				// 	const dropdown = document.createElement('div');
				// 	dropdown.className = 'sso-vertical-dropdown';

				// 	const dropdownView = document.createElement('div');
				// 	dropdownView.setAttribute('data-view', 'Header.SSO.Services');

				// 	dropdown.appendChild(dropdownView);
				// 	menuItem.appendChild(dropdown);

				// 	const membersDirectoryLink = headerMenu.querySelector('a[href="/membershipdirectory"]');
				// 	if (membersDirectoryLink) {
				// 		const membersDirectoryItem = membersDirectoryLink.closest('li');
				// 		if (membersDirectoryItem && membersDirectoryItem.nextElementSibling) {
				// 			membersDirectoryItem.parentElement.insertBefore(menuItem, membersDirectoryItem.nextElementSibling);
				// 		} else if (membersDirectoryItem) {
				// 			membersDirectoryItem.parentElement.appendChild(menuItem);
				// 		}
				// 	} else {
				// 		headerMenu.appendChild(menuItem);
				// 	}

				// 	const services = getSSOServices();
				// 	if (profile && profile.get('isLoggedIn') === 'T' && services && services.length > 0) {
				// 		try {
				// 			const ssoServicesView = new NVTSSOServicesView({
				// 				services: services,
				// 				el: dropdownView
				// 			});
				// 			ssoServicesView.render();
				// 		} catch (e) {
				// 			console.warn('SSO Services View rendering error:', e);
				// 		}
				// 	}
				// }

				// document.addEventListener('click', function (event) {
				// 	const toggleButton = event.target.closest('.sso-services-toggle');

				// 	if (toggleButton) {
				// 		event.preventDefault();
				// 		event.stopPropagation();
				// 		const profile = ProfileModel.getInstance();
				// 		if (profile && profile.get('isLoggedIn') !== 'T') {
				// 			sessionStorage.setItem('ral', 'services');
				// 			window.location.href = SC.CONFIGURATION.siteSettings.touchpoints.login;
				// 			return;
				// 		}
				// 		const menuItem = toggleButton.closest('.header-menu-item.sso-services-item');
				// 	}
				// });

				// document.addEventListener('click', function (event) {
				// 	const menuItem = event.target.closest('.header-menu-item.sso-services-item');

				// 	if (!menuItem) {
				// 		const allDropdowns = document.querySelectorAll('.sso-vertical-dropdown.sso-open');
				// 		const allToggleButtons = document.querySelectorAll('.sso-services-toggle.active');

				// 		allDropdowns.forEach(dropdown => {
				// 			dropdown.classList.remove('sso-open');
				// 		});
				// 		allToggleButtons.forEach(btn => {
				// 			btn.classList.remove('active');
				// 		});
				// 	}
				// });

				// setTimeout(injectSSOServicesMenu, 100);

				// function waitForElement(selector, callback, maxRetries = 10) {
				// 	let retries = 0;
				// 	const checkElement = function () {
				// 		const element = document.querySelector(selector);
				// 		if (element) {
				// 			callback(element);
				// 		} else if (retries < maxRetries) {
				// 			retries++;
				// 			setTimeout(checkElement, 200);
				// 		} else {
				// 			console.warn('Element not found after retries:', selector);
				// 		}
				// 	};
				// 	checkElement();
				// }

				// setTimeout(function () {
				// 	const profile = ProfileModel.getInstance();
				// 	const redirectToSSO = sessionStorage.getItem('ral');

				// 	if (profile && profile.get('isLoggedIn') === 'T' && redirectToSSO === 'services') {
				// 		waitForElement('.sso-services-toggle', function (toggleButton) {
				// 			const menuItem = toggleButton.closest('.header-menu-item.sso-services-item');

				// 			if (menuItem) {
				// 				const dropdown = menuItem.querySelector('.sso-vertical-dropdown');
				// 				if (dropdown) {
				// 					const dropdownContent = dropdown.querySelector('[data-view]');
				// 					if (dropdownContent) {
				// 						dropdown.classList.add('sso-open');
				// 						toggleButton.classList.add('active');
				// 					}
				// 				}
				// 			}
				// 		});
				// 	}
				// 	sessionStorage.removeItem('ral');
				// }, 500);

				const pageType = container.getComponent('PageType');
				pageType.registerPageType({
					name: 'customssoservice',
					routes: ['ssoservicelist'],
					view: SSOMechanismView,
					defaultTemplate: {
						name: 'nvt_sso_mechanism_ssomechanism.tpl',
						displayName: 'Services'
					}
				});

				// This works for both desktop and mobile
				const userProfile = container.getComponent('UserProfile');
				userProfile.getUserProfile().then(function (profile) {
					if (profile.isloggedin) {
						// Handle redirect
						const redirectToSSO = sessionStorage.getItem('redirectAfterLogin');
						if (redirectToSSO) {
							sessionStorage.removeItem('redirectAfterLogin');
							window.location.href = SC.ENVIRONMENT.siteSettings.touchpoints.home + redirectToSSO;
						}

						// const MyAccountMenu = container.getComponent('MyAccountMenu');
						// MyAccountMenu.addGroup({
						// 	id: 'ssoservicelist',
						// 	name: Utils.translate('Services'),
						// 	index: 99,
						// 	url: 'ssoservicelist'
						// });
					}
				});
			}
		};
	}
);
